import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateService} from "app/translate/translate.service";
import {FilterFormService} from "app/views/filter_form/filter_form.service";
import {HelperService} from "app/lib/helper.service";
import {ChartParams} from "app/views/chart/chart.component";
import {BaseComponent} from "app/views/base.component";
import {EventsService} from "app/lib/EventsService";
import {ModalService} from "app/views/modal/base_modal.component";
import { UserService } from "../user.service";
import { ICharts } from "../../models/responce_result.model";
import { FilterParams } from "../../models/filter_form.model";

interface IActivityOneDayStats extends ICharts {
	userCount: number;
	categories: string[];
}

interface IActivityCharts extends ICharts {
	totals: {
		totalCount: number;
		queryCount: number;
		afterLevel: number;
		beforeLevel: number;
	};
	categories: string[];
}

@Component({
	selector: 'activity',
	templateUrl: './activity.component.html'
})
export class ActivityComponent extends BaseComponent {
	oneDayChart = new ChartParams({
		type: 'bar',
		grid: {
			y: {
				lines: [{value: 0}]
			}
		},
		axis: {
			x: {
				type: 'category',
				tick: {
					culling: {
						max: 10
					}
				}
			}
		}
	});
	widgetChart = new ChartParams({
		type: 'bar',
		grid: {
			y: {
				lines: [{value:0}]
			}
		},
		axis: {
			x: {
				type: 'category',
				tick: {
					culling: {
						max: 30
					}
				}
			},
		}
	});
	actionChart = new ChartParams({
		type: 'bar',
		grid: {
			y: {
				lines: [{value:0}]
			}
		},
		axis: {
			x: {
				type: 'category',
				tick: {
					culling: {
						max: 20
					}
				}
			},
		}
	});

	oneDayUserCount: number;

	widgetData: any = {};
	actionData: any = {};

	constructor(
		public eventsService: EventsService,
		public helper: HelperService,
		public activatedRoute: ActivatedRoute,
		public translate: TranslateService,
		public router: Router,
		public modalService: ModalService,
		public filter: FilterFormService,
		public userService: UserService,
	) {
		super(eventsService, userService, activatedRoute, filter, translate);
		
		this.oneDayChart.setOptions({
			title: 'OneDay user activity',
			axis: {
				y: {
					label: {
						text     : this.translate.__A('users.graph.user percent'),
						position : 'outer-middle'
					}
				},
				x: {
					label: {
						text     : this.translate.__A('users.graph.hours'),
						position : 'outer-middle'
					}
				}
			},
			names: {
				'userCount': 'Users, (%)'
			}
		});
		
		this.widgetChart.setOptions({
			title: this.translate.__A('users.graph.about widgets'),
			axis: {
				x: {
					label: this.translate.__A('users.graph.widget-count'),
				},
				y: {
					label: this.translate.__A('users.graph.site-count'),
				}
			},
			names: {
				'count': this.translate.__A('users.graph.Distribution by widget count'),
			}
		});
		
		this.actionChart.setOptions({
			title: this.translate.__A('users.graph.about actions'),
			type: 'bar',
			axis: {
				x: {
					label: this.translate.__A('users.graph.action-count'),
				},
				y: {
					label: this.translate.__A('users.graph.user-count'),
				}
			},
			names: {
				'count': this.translate.__A('users.graph.Distribution by action count'),
			}
		});
	}


	async getData() {
		await this.getOneDayChart();
		await this.getWidgetChart();
		await this.getActionChart();
	}


	async getOneDayChart() {
		this.oneDayChart.showLoader();

		const { charts, userCount } = await this.userService.activity.get<IActivityOneDayStats>(
			this.filter.filterParams,
			'oneday'
		).toPromise();
		this.oneDayChart.data = charts;
		this.oneDayUserCount = userCount;
		
		this.oneDayChart.hideLoader();
	}

	async getWidgetChart() {
		this.widgetChart.showLoader();

		const { charts, totals, categories } = await this.userService.activity.chart<IActivityCharts>(
			this.filter.getCopyFilterParams(<FilterParams>{
				widgetStartCount: this.widgetData.startCount,
				widgetEndCount: this.widgetData.endCount,
				widgetBorder: this.widgetData.border
			}),
			'widget'
		).toPromise();


		this.widgetChart.data = charts;
		this.widgetChart.setOptions({
			axis: {
				x: {
					categories,
				}
			}
		});
		this.widgetData = totals;

		this.widgetChart.hideLoader();
	}

	async getActionChart() {
		this.actionChart.showLoader();

		const { charts, totals, categories } = await this.userService.activity.chart<IActivityCharts>(
			this.filter.getCopyFilterParams(<FilterParams>{
				activityStartCount: this.actionData.startCount,
				activityEndCount: this.actionData.endCount,
				activityBorder: this.actionData.border
			}),
			'activity'
		).toPromise();

		this.actionChart.data = charts;
		this.actionChart.setOptions({
			axis: {
				x: {
					categories,
				}
			}
		});
		this.actionData = totals;

		

		this.actionChart.hideLoader();
	}

	async customApplyFilters(type: string) {
		if (type == 'widget') {
			await this.getWidgetChart();
		} else if (type == 'action') {
			await this.getActionChart();
		}
	}

	async customResetFilters(type: string) {
		if (type == 'widget') {
			this.widgetData = {};
			await this.getWidgetChart();
		} else if (type == 'action') {
			this.actionData = {};
			await this.getActionChart();
		}
	}
}
